import { PublishStatusType, WorkplanPublishStepCode, UkgDateFormat } from 'src/Enums';
import DateFormatService from '../../../services/DateFormatService';

/**
 * 
 * @param {WorkplanPublishStepCode} stepCode 
 * @param {boolean} isRebid 
 * @param {BidProfileManagement.IBidProfileManagement} bidProfileManagementInfos 
 * @returns 
 */
export const getStepInfo = (stepCode, isRebid, bidProfileManagementInfos) => {
    const { rolloutErrors, employeesBidSelection, awardingResults } = bidProfileManagementInfos;
    const completionErrors = employeesBidSelection
        .filter((x) => !!x.completionError)
        .map((x) => ({
            name: `${awardingResults.find((result) => result.employeeId === x.employeeId)?.employee.fullName} (${x.employeeId})`,
            error: x.completionError,
        }));
    const parsedRolloutErrors = rolloutErrors.map((x) => ({
        name: 'System', error: x,
    }));
    /**
     * @type {WorkplanPublishProgress.IStepInfoItem[]}
     */
    const defaultStepInfo = [ // Steps are publishing by default
        { stepNumber: WorkplanPublishStepCode.PreparingData, stepStatus: PublishStatusType.Publishing, errors: [] },
        { stepNumber: WorkplanPublishStepCode.ShiftlineAssignations, stepStatus: PublishStatusType.Publishing, errors: completionErrors },
    ];
    if (!isRebid) {
        defaultStepInfo.push({ stepNumber: WorkplanPublishStepCode.WorkplanRollout, stepStatus: PublishStatusType.Publishing, errors: parsedRolloutErrors });
    }

    // Set status of steps before step that is currently processing
    const stepInfo = defaultStepInfo.map((x) => {
        if (x.stepNumber < stepCode) {
            return {
                stepNumber: x.stepNumber,
                stepStatus: x.errors.length ? PublishStatusType.Warning : PublishStatusType.Success,
                errors: x.errors,
            };
        }
        return x;
    });
    return stepInfo;
};

/**
 * @param {ApiManager.GetWorkplanPublishProgressResponse} response
 * @param {BidProfileManagement.IBidProfileManagement} bidProfileManagementInfos
 * @param {BidProfile.IBidProfile} bidProfile
 * @returns {WorkplanPublishProgress.IPublishProgress}
 */
export const parseWorkplanPublishProgressResponse = (response, bidProfileManagementInfos, bidProfile) => {
    const { progress, stepCode, isComplete } = response.data;
    const { originalSchedule, isForeverRequestPeriod, isRebid } = bidProfile;

    // Set status of steps before step that is currently processing
    const stepInfo = getStepInfo(stepCode, isRebid, bidProfileManagementInfos);

    /**
     * @type {PublishStatusType}
     */
    let status = PublishStatusType.Publishing;
    
    const hasErrors = stepInfo.find((x) => x.errors.length >= 1);
    
    if (isComplete) {
        status = hasErrors ? PublishStatusType.Error : PublishStatusType.Success;
    } else if (hasErrors) {
        status = PublishStatusType.Error;
    }

    return {
        workplanName: 'Workplan', // TODO - WP must provide WP currently being rolled out
        effectiveDate: DateFormatService.formatDateOrEmpty(originalSchedule.requestPeriodStartDate, UkgDateFormat.LongDate),
        endDate: DateFormatService.formatDateOrEmpty(originalSchedule.requestPeriodEndDate, UkgDateFormat.LongDate),
        isForeverRequestPeriod,
        status,
        stepInfo,
        progressValue: progress,
        progressStepCode: stepCode,
        isComplete,
        isProgressSidePanelOpen: true,
    };
};
